import * as React from "react"
import "./LoginLanguageSelector.scss"

import { Select } from "@walmart-web/livingdesign-components"
import { useApplicationContext } from "context/applicationContext"
import { LANGUAGE_EN, LANGUAGE_ES } from "constants/language"
import { useIntl } from "react-intl"
import { getStoredLanguage } from "context/language"

const LoginLanguageSelector: React.FC = (): JSX.Element => {
	const intl = useIntl()
	const [language, setLanguage] = React.useState<string>(
		getStoredLanguage() || LANGUAGE_EN
	)

	const { selectLanguage } = useApplicationContext()

	const handleOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		selectLanguage(event.target.value)
		setLanguage(event.target.value)
	}

	return (
		<div className={"top-bar"}>
			<Select
				label={""}
				onChange={handleOnChange}
				value={language}
				className={"select"}
			>
				<option value={LANGUAGE_ES}>
					{intl.formatMessage({
						id: "phronesis.login.language.selector.spanish",
					})}
				</option>
				<option value={LANGUAGE_EN}>
					{intl.formatMessage({
						id: "phronesis.login.language.selector.english",
					})}
				</option>
			</Select>
		</div>
	)
}
export default LoginLanguageSelector
